module.exports = __webpack_public_path__ + "static/img/wf.e3ac728c.svg";